module.exports = __webpack_public_path__ + "static/media/code.00c47a20.svg";